export const accordionStyles = {
  button: {
    px: 0,
    py: 0,
    fontSize: '15px',
    _hover: {},
    _active: {},
  },
  item: {
    border: 'none',
    p: 0,
  },
  panel: {
    p: 0,
  },
};
